import { React } from 'react';
import styled from 'styled-components';

import { ReactComponent as SearchingSvg } from '../../image/Searching.svg';

export default function NewSearchInput(props) {
	const { placeholder, value, setValue } = props;
  
	function handleChange(e) {
		setValue(e.target.value);
	}

	function handleFocus(e) {
    setValue('');
	}

  return (
    <TopLevelWrapper>
      <InputWrapper>
        <StyledSearching />
        <Input
          type='text'
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus} />
      </InputWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 100%;
`;

const StyledSearching = styled(SearchingSvg)`
  position: absolute;
  left: 10px;

  flex-shrink: 0;
  width: 20px;
  height: auto;

  & path {
    fill: ${props => props.theme.text};
  }
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 12px;

  padding: 0 0 0 40px;
  width: calc(100% - 42px);
  height: 34px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
	color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

	&::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 12px;

		color: ${props => props.theme.text};
	}

  transition: all 0.3s ease-in-out;
`;